import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

export const countrySchema = z.object({
  id: z.string(),
  locale: z.string(),
  name: z.string(),
  currencyCode: z.string(),
  currencyName: z.string(),
  currencySymbol: z.string().optional().nullable(),
  createdAt: z.coerce.date(),
});

export class CountryDto extends createZodDto(countrySchema) {}
